export class CreateMPAPolicyResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mpaPolicy",
            "baseName": "mpaPolicy",
            "type": "MPAPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateMPAPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
